'use strict'
import QS from 'qs'
import Axios from 'axios'
import url from '@/utils/server'
import utils from '@/utils/utils'
import toaster from '@/utils/toaster'
import store from '@/store/index'
var baseurl = url.apiurl
console.log(window.localStorage.getItem('web'))

import { Message, MessageBox } from 'element-ui'
import { el } from 'element-plus/es/locales.mjs'

// http request 拦截器
Axios.interceptors.request.use(
  config => {
    config.paramsSerializer = function (params) {
      return QS.stringify(params, { arrayFormat: 'repeat' })
    }
    // if (config.url.includes('app-api')) {
    //   ;(config.baseURL = 'http://192.168.1.236:8080/'), (config.headers['villageid'] = window.localStorage.getItem('villageId'))
    //   if (config.url.includes('sysVillageAgri')) {
    //     // config.headers['Content-type'] = 'application/json'`
    //   }
    // } else
    if (window.localStorage.getItem('web') == 236) {
      config.baseURL = baseurl + '236'
      console.log(config.baseURL)
    } else {
      console.log(789)
      config.baseURL = baseurl
    }
    if (!config['params']) {
      config['params'] = {}
    }
    if (config.params['token1']) {
      config.headers['AUTHORIZATION'] = store.state.user.token
    }
    config.headers['AUTHORIZATION'] = store.state.user.token
    config.headers['userId'] = sessionStorage.getItem('USER_ID')
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// 添加响应拦截器
Axios.interceptors.response.use(
  res => {
    // 对响应数据做点什么
    switch (res.data.code) {
      case 200:
        return res.data
        break
      case 402:
        MessageBox.confirm(`${res.data.msg}，可以取消继续留在该页面，或者重新登录`, '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let userName = window.localStorage.getItem('userNameZ')
          let pwdZ = window.localStorage.getItem('pwdZ')
          utils.delAllStorage()
          utils.delAllSession()
          if (userName && userName != null) {
            window.localStorage.setItem('userNameZ', userName)
            window.localStorage.setItem('pwdZ', pwdZ)
          }
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        break
      case undefined:
        return res
        break
      default:
        toaster.error('', res.data.msg, 1500)
        // return Promise.reject(res.data)
        return res.data
        break
    }
  },
  error => {
    // 如果需要通过服务端返回的数据在组件内进行判定，
    // 由于拦截器是reject的错误，并不能在组件中读取err信息，可以改reject为 resolve 并且返回err.response
    // 对响应错误做点什么
    let code = error.response.status // 获取错误状态码
    let msg = error.response.data.msg // 获取提示信息
    switch (code) {
      case 401:
        MessageBox.confirm(`${msg}，可以取消继续留在该页面，或者重新登录`, '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let userName = window.localStorage.getItem('userNameZ')
          let pwdZ = window.localStorage.getItem('pwdZ')
          utils.delAllStorage()
          utils.delAllSession()
          if (userName && userName != null) {
            window.localStorage.setItem('userNameZ', userName)
            window.localStorage.setItem('pwdZ', pwdZ)
          }
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        break
      case undefined:
        toaster.error('网络异常', '', 1500)
        return Promise.reject(error)
        break
      default:
        toaster.error('网络异常', '', 1500)
        return Promise.reject(error)
        break
    }
  }
)
export default {
  get: option => {
    var options = {
      url: option.url,
      timeout: 1000000000000000000000000000000,
      method: option.method || 'get',
      params: option.data || {},
      success: option.succ || function (res) {},
      error: option.error || function (res) {}
    }
    return Axios.request(options)
  },
  post: option => {
    var options = {
      url: option.url,
      timeout: 1000000000000000000000000000000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      method: option.method || 'post',
      data: option.data,
      success: option.succ || function (res) {},
      error: option.error || function (res) {}
    }
    if (option.data && option.typea == 1) {
      options.headers['content-Type'] = 'application/json;charset=utf-8'
      options.beforeSend = function (xhr) {
        xhr.setRequestHeader('Test', 'testheadervalue')
      }
    } else if (option.data && option.typeb == 'excel') {
      options.responseType = 'blob'
      options.data = QS.stringify(options.data)
    } else if (option.data && option.typea == 2) {
      options.headers['content-Type'] = 'multipart/form-data'
    } else {
      options.data = QS.stringify(options.data)
    }
    return Axios.request(options)
  },
  delete: option => {
    var options = {
      url: option.url,
      timeout: 1000000000000000000000000000000,
      method: option.method || 'delete',
      params: option.data || {},
      success: option.succ || function (res) {},
      error: option.error || function (res) {}
    }
    return Axios.request(options)
  },
  put: option => {
    var options = {
      url: option.url,
      timeout: 1000000000000000000000000000000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      method: option.method || 'PUT',
      params: option.data || {},
      success: option.succ || function (res) {},
      error: option.error || function (res) {}
    }
    if (option.data && option.typea == 1) {
      options.headers['content-Type'] = 'application/json;charset=utf-8'
      options.data = QS.stringify(options.data)
    }
    return Axios.request(options)
  }
}
